var map = {
	"./P3-scaled.jpg": "48ac",
	"./Pro-1.jpg": "c9f4",
	"./Pro-2.jpg": "2ead",
	"./Pro-3.jpg": "bfda",
	"./Pro-4.jpg": "3ef4",
	"./Shiba-BG.jpg": "12e1",
	"./Shiba-BG1.jpg": "b6e8",
	"./aladin.jpg": "a190",
	"./avatar-01.jpg": "5f80",
	"./bank/baac.jpg": "e45b",
	"./bank/bankokbank.jpg": "029f",
	"./bank/cimb.jpg": "3a74",
	"./bank/ghbank.jpg": "d1a9",
	"./bank/gsb.jpg": "d79f",
	"./bank/icbc.jpg": "9bed",
	"./bank/kbank.jpg": "25e9",
	"./bank/kiatnakin.jpg": "f79e",
	"./bank/krungsri.jpg": "6827",
	"./bank/ktb.jpg": "ed77",
	"./bank/lh.jpg": "d9be",
	"./bank/scb.jpg": "c6ff",
	"./bank/standard.jpg": "ac03",
	"./bank/tisco.jpg": "3b85",
	"./bank/truewallet.jpg": "6466",
	"./bank/ttb.jpg": "2906",
	"./bank/uob.jpg": "5191",
	"./bank/ธนาคารอิสลาม.jpg": "0387",
	"./bg_home.jpg": "8435",
	"./bg_wedo.jpg": "cd84",
	"./icon-fb-bttm.jpg": "6d98",
	"./img-01.jpg": "d695",
	"./merry.jpg": "eb43",
	"./natural-paper-texture.jpg": "74e8",
	"./truebank.jpg": "9626"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5a1";